import { ccs } from "../types";

const INITIAL_STATE = {
      error: undefined,
      conversationView: false,
      calendarView: false,
      activeConversation: {},
      message: { text: '' },
      searchedText: '',
      messageQueue: {},
      conversationList: [],
      supportList: [],
      myTicketsList: [],
      sortBy: 'lastActivity',
      eyesClicked: [],
      ticketListLoading: true,
      messagesLoading: true,
      supportListLoading: true,
      myTicketsListLoading: true,
      customerId: 'all',
      projectId: 'all',
      conversationDetails: {},
      conversationCount: {
          tickets: 0,
          support: 0,
          mytickets: 0
      },
      conversationsScrollLock: false,
      ticketScrollListLoading: false,
      isConnected: undefined,
      showOpenHelpScreen: false,
      openHelpButtonLoading: false,
      assigneeList: {}
  }
  


const cssreducer =  (state = INITIAL_STATE, action) => {
      switch (action.type) {
      case ccs.CCS_UPLOAD_FILES_SUCCESS: {
                  const { media, _id, isSignOff } = action.payload;
                  const conversationDetails = Object.assign({}, state.conversationDetails);
                  if (isSignOff && conversationDetails[_id]) {
                      conversationDetails[_id].media = media;
                  }
                  return {
                      ...state,
                      conversationDetails
                  }
      }      

      case ccs.CCS_ADD_TO_MESSAGE_QUEUE_SUCCESS: {
      let { action: qAction, message: qMsg } = action.payload;
      const defaults = {
          attachments: [],
          edited: false,
          updatedAt: new Date(),
          deletedFor: 'NOT_DELETED',
          deletedAt: new Date(),
          editHistory: [],
          repliedTo: {},
          deliveredReceipts: [],
          readReceipts: [],
          sentAt: new Date()
      }
      qMsg = { ...defaults, ...qMsg };
      const messageQueue = Object.assign({}, state.messageQueue);
      if (messageQueue[qMsg.conversation]) {
          messageQueue[qMsg.conversation][qAction] = messageQueue[qMsg.conversation][qAction] ? messageQueue[qMsg.conversation][qAction].filter(msg => msg._id !== qMsg._id).concat(qMsg) : [qMsg];
      } else {
          messageQueue[qMsg.conversation] = { [qAction]: [qMsg] };
      }
      const messageList = Object.assign({}, state.messageList);
      if (qAction === 'sendMessage') {
          if (messageList[qMsg.conversation]) {
              messageList[qMsg.conversation] = messageList[qMsg.conversation].filter(msg => msg._id !== qMsg._id).concat(qMsg);
          }
      }
      return {
          ...state,
          messageList,
          messageQueue
      };
      }
      default:
            return {
                ...state
       }

}
}

export default cssreducer
